import axios from "../../config/axiosConfig";
import {
  PURCHASE_SALE_ORDER_BALANCE_REPORT_REQUEST,
  PURCHASE_SALE_ORDER_BALANCE_REPORT_SUCCESS,
  PURCHASE_SALE_ORDER_BALANCE_REPORT_FAILURE,
} from "../types/purchase-sale-order-balance-report-types";

export const getPurchaseSaleOrderBalanceReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_SALE_ORDER_BALANCE_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams };

      // Log the request parameters
      console.log('Request Param Datas >>>>>', requestParams);

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/purchase-sale-order-balance-report/get?${queryString}`;

      // Log the full URL (to debug)
      console.log('>>Complete API Request URL: ', fullUrl);

      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('<<<Purchase API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: PURCHASE_SALE_ORDER_BALANCE_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching production detail yarn Report:", error);
        dispatch({ type: PURCHASE_SALE_ORDER_BALANCE_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching production detail yarn Report:", error);
      dispatch({ type: PURCHASE_SALE_ORDER_BALANCE_REPORT_FAILURE, error: error.message });
    }
  };
};

export const clearPurchaseSaleOrderBalanceReport = () => {
  return async (dispatch) => {
        dispatch({ type: PURCHASE_SALE_ORDER_BALANCE_REPORT_SUCCESS, payload: {} });
  }
}
